import {z} from 'zod';
import {FCResourceType} from './resourceKnowledgeTool.enums';
import {ragSearchResponseSchema} from '../../copilot.schemas';

const resourceKnowledgeToolInputSchema = z.object({
  resourceType: z
    .nativeEnum(FCResourceType)
    .describe('The type of resource that the question is about'),
  resourcesToFetch: z
    .string()
    .describe(
      'Natural language DB search for resources of the resource type. Do not specify what you want to know about the resource, just which resources you want to filter/fetch. Phrase as "search for...". NEVER mention the resource type in the search query.',
    ),
  isQuestionTooBroad: z
    .boolean()
    .describe("Whether the user's question is too broad ('which resources are available?')"),
  prompt: z
    .string()
    .describe(
      'The prompt you want an answer for, based on the resources found as a result of the search',
    ),
});

const resourceLlmCallResponseSchema = ragSearchResponseSchema.extend({
  relevantTempIds: z
    .array(z.string())
    .describe("The temp IDs of the resources that are relevant to the user's question"),
  additionalInstructions: z.string(),
});

export {resourceKnowledgeToolInputSchema, resourceLlmCallResponseSchema};
